import { z } from 'zod';
export const tokenWithExpirationSchema = z.object({
    token: z.string(),
    issuedAt: z.number(),
    validForMs: z.number(),
});
export const getTokenExpiresAt = ({ issuedAt, validForMs, }) => {
    return issuedAt + validForMs;
};
export const isTokenPossiblyValid = (token) => {
    const expiresAt = getTokenExpiresAt(token);
    return expiresAt > Date.now();
};
export const getMsToTokenExpiration = (token) => {
    const expiresAt = getTokenExpiresAt(token);
    return expiresAt - Date.now();
};
